// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1i4bm","log":"ModalInventoryLogs_log__rEx7l","date":"ModalInventoryLogs_date__1gmvA","userName":"ModalInventoryLogs_userName__3NW38"};